import { BooleanProperty as BoolProp } from '../../peregrineFlowInterfaces';
import { Switch, Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { NodePropertyProp } from '../NodePropertyPane';
import { useCallback, useEffect, useState } from 'react';

function BooleanProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as BoolProp;
    const [checked, setChecked] = useState<boolean>(false);

    useEffect(() => {
        setChecked(p.value)
    }, [p])

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        p.value = event.target.checked
        onChange?.(p)
        setChecked(event.target.checked)

    }, [p, onChange]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <Switch checked={checked} onChange={handleChange} />
        </Box>
    )
}

export default BooleanProperty;
